import { GetSyntheticaVessels } from '../../api/synthetica';
import { useMemo, useState } from "react";
import { SEAJAPAN_TEST_VESSEL, TEST_VESSEL } from '../../constants/synthetica';

const emptyOutput = {
    isLoading: false,
    hasData: false,
    vesselStatus: [],
    ciiOverTime: [],
    vesselPerformance: [],
    voyageHistory: [],
}

export const useSyntheticaData = ({ vesselName }) => {
    const [synthData, setSynthData] = useState({...emptyOutput, isLoading: true});

    const fetchData = async () => {
        if(vesselName == null){
            return;
        }

        if (vesselName.toUpperCase() === SEAJAPAN_TEST_VESSEL) {
          vesselName = TEST_VESSEL;
        }

        const vesselData = await GetSyntheticaVessels();
        const foundVessel = vesselData?.find((v) => v.vessel_name?.toLowerCase() == vesselName.toLowerCase());
        if(foundVessel == null){
            setSynthData(emptyOutput);
        }
    }
    useMemo(() => {
        fetchData();
    }, [vesselName]);

    return synthData;
}
